import styles from './ServiceUser.module.css';
import '../../resources/css/admin_style.css';
import React, { useContext, useEffect, useState } from "react";
import Loading from "../../utils/loading/Loading";
import { ModalContext } from "../../utils/modal/ModalProvider";
import { IAM_SERVER_SERVICE_USER } from "../../utils/Config";
import axios from "../../utils/api/axios";
import DetailModal from "../../utils/modal/DetailModal";
import { ServiceUserDetailModal } from "./modal/ServiceUserDetailModal";
import DatePicker from "react-datepicker";
import { ko } from "date-fns/locale/ko";
import dayjs from "dayjs";
import { TableContext, TableStateType } from '../../utils/contextapi/TableProvider';
import { useServiceList } from '../../utils/service/serviceList';
import { useSelectedService } from '../../utils/contextapi/ServiceProvider';
import ServiceUserTable from './component/ServiceUserTable';
import { ServiceUserAdminRegisterModal, ServiceUserRegisterModal } from './modal/ServiceUserAdminRegisterModal';

export const ModalEnum = {
    //기기 관리 Modal Enum
    REGISTER: 'register_one_button',
    DETAIL: 'modify_and_delete_two_button'
}

/**
 * 서비스 사용자 관리 화면
 * @param isMobile
 * @param setMovePage
 * @returns {JSX.Element}
 * @constructor
 */
function ServiceUser({ isMobile, setMovePage }) {

    const { openModal } = useContext(ModalContext);
    const [loading, setLoading] = useState(false);

    const [isMobileWindow, setIsMobileWindow] = useState(false);
    const context = useContext(TableContext);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileWindow(window.innerWidth < 768); // 모바일 기준 너비
        };
        handleResize(); // 초기값
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    //검색 조건
    const [searchValue, setSearchValue] = useState('');

    //테이블 데이터
    const [cellData, setCellData] = useState([]);
    const [page, setPage] = useState(0);
    const listSize = 10; // 한 페이지당 보여줄 항목 수
    const [totalCount, setTotalCount] = useState(0);

    // 정렬 Custom
    const [sortModel, setSortModel] = React.useState({
        field: "createdDate",   // 현재 정렬 기준값
        sort: "desc",   // (asc: 오름차순, desc: 내림차순)
    });

    const { selectedService } = useSelectedService();

    // page 또는 정렬 조건이 바뀔 때마다 Reloading
    useEffect(() => {
        if (selectedService) {
            fetchData(page, listSize);
        }
    }, [page, sortModel]);

    useEffect(() => {
        if (selectedService) {
            fetchData();
        } else {
            setCellData([]);
        }
    }, [selectedService]);


    // 데이터 테이블 조회 API
    const fetchData = async (page = 0, size = listSize, searchType = '', searchValue = '') => {
        setLoading(true);

        try {
            // dateRange 가져오기 (context로부터 최신 상태를 반영)
            const [start, end] = context.state.dateRange;
            const startDate = new Date(start).getTime();
            const endDate = new Date(end).getTime();

            // 필수 조건: 날짜 범위 조건
            const conditions = [
                { field: "createdDate", operator: "GREATER_THAN_OR_EQUAL", value: startDate },
                { field: "createdDate", operator: "LESS_THAN_OR_EQUAL", value: endDate },
                { field: "serviceId", operator: "EQUALS", value: selectedService.serviceId }
            ];

            // 선택 조건: 검색 조건 있을 때만 추가
            if (searchType.trim() && searchValue.trim()) {
                conditions.push({
                    field: searchType,
                    operator: "LIKE",
                    value: searchValue
                });
            }
            console.log(conditions);

            // 최종 params 구성
            const params = {
                page: page,
                size: listSize,
                sortField: [sortModel.field],
                sortOrder: [sortModel.sort],
                operator: "AND",
                conditions
            };

            const res = await axios.post(IAM_SERVER_SERVICE_USER + '/all-iam-service', params);
            const { data, recordsTotal } = res.data.data;

            setTotalCount(recordsTotal);
            setCellData(data);

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    //검색 조회
    const handleSearch = async (searchType, value) => {
        setPage(0);
        fetchData(0, listSize, searchType, value);
    }

    // 사용자 상세정보 모달 핸들러
    const handleDetailInfo = (data) => {
        const modalContent = <ServiceUserDetailModal data={data} update={fetchData} serviceId={selectedService.serviceId} />
        const modalOption = { modalTitle: '상세 정보' }
        openModal(<DetailModal content={modalContent} option={modalOption} />)
    };

    // 서비스 관리자 등록 모달
    const handleRegister = () => {
        const modalContent = <ServiceUserAdminRegisterModal update={fetchData} service={selectedService} />
        const modalOption = { modalTitle: '관리자 등록' }
        openModal(<DetailModal content={modalContent} option={modalOption} />)
    };

    const handleNextPage = () => {
        setPage((prevPage) => {
            const newPage = prevPage + 1;
            return newPage;
        });
    };

    const handlePrevPage = () => {
        setPage((prevPage) => {
            const newPage = Math.max(prevPage - 1, 0);
            return newPage;
        });
    };

    return (
        <div className={styles.layoutWrapper}>
            <h3>서비스 사용자 관리</h3>
            <div className={styles.pannelWrapper} >
                <div className={styles.permissionPanel}>
                    <ServiceUserTable
                        datas={cellData}
                        context={context}
                        detailUser={handleDetailInfo}
                        registerUser={handleRegister}
                        onPrevPage={handlePrevPage}
                        onNextPage={handleNextPage}
                        disablePrev={page === 0}
                        disableNext={(page + 1) * listSize >= totalCount}
                        pageNumber={page}
                        totalCount={totalCount}
                        listSize={listSize}
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                        onSearch={handleSearch}
                        isMobileWindow={isMobileWindow}
                    />
                </div>
            </div>
        </div>
    )
}

export default ServiceUser;